import React, { useState, useEffect } from 'react';
import { Menu as MenuIcon, X } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    setIsMobileMenuOpen(false);
    if (window.__lenis) {
      window.__lenis.scrollTo(`#${id}`, { offset: -72 });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { name: 'Services', id: 'services' },
    { name: 'Menu', id: 'menu' },
    { name: 'Tour', id: 'virtual-tour' },
    { name: 'Events', id: 'events' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'border-b border-[#f4ede3]/10 bg-[#14100d]/90 backdrop-blur-xl'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <div className="flex h-[72px] items-center justify-between">
          {/* Logo */}
          <button
            data-testid="nav-logo"
            className="flex items-baseline gap-1.5"
            onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: 'smooth' }))}
          >
            <span className="font-display text-2xl font-black tracking-tight text-[#f4ede3]">VIBE</span>
            <span className="font-display text-lg font-light italic text-[#f2a33c]">café</span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden items-center gap-8 md:flex">
            {navLinks.map((link) => (
              <button
                key={link.id}
                data-testid={`nav-link-${link.id}`}
                onClick={() => scrollToSection(link.id)}
                className="font-body text-[13px] font-medium uppercase tracking-[0.18em] text-[#b8ac9c] transition-colors duration-300 hover:text-[#f2a33c]"
              >
                {link.name}
              </button>
            ))}
            <button
              data-testid="nav-book-button"
              className="btn-pill font-body !px-6 !py-2.5 text-[13px] uppercase tracking-[0.12em]"
              onClick={() => scrollToSection('booking')}
            >
              Book Space
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="nav-mobile-toggle"
            className="p-2 text-[#f4ede3] md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <MenuIcon size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="border-t border-[#f4ede3]/10 bg-[#14100d]/95 py-4 backdrop-blur-xl md:hidden">
            {navLinks.map((link) => (
              <button
                key={link.id}
                data-testid={`nav-mobile-link-${link.id}`}
                onClick={() => scrollToSection(link.id)}
                className="font-body block w-full px-2 py-3 text-left text-sm uppercase tracking-[0.18em] text-[#b8ac9c] transition-colors hover:text-[#f2a33c]"
              >
                {link.name}
              </button>
            ))}
            <div className="px-2 pt-3">
              <button
                data-testid="nav-mobile-book-button"
                className="btn-pill font-body w-full justify-center"
                onClick={() => scrollToSection('booking')}
              >
                Book Space
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
